export function resetsAgreementAcceptance(
    previousBrokerFirmId: number | undefined,
    nextBrokerFirmId: number
): boolean {
    return previousBrokerFirmId !== undefined && previousBrokerFirmId !== nextBrokerFirmId;
}
